// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MetalSelector_wrapper__2xRcD","colorPrev":"MetalSelector_colorPrev__3OVud","text":"MetalSelector_text__262iw"};